import React from 'react'

import LetterLandingCTO from '../LetterLandingCTO';

import logo_target from '../../../images/letterfunnel/vormats.webp';
import screenshot_target from '../../../images/letterfunnel/andresampaio.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLandingCTO
      fullname="André Sampaio"
      firstname="André"
      companyname="Vormats"
      competition="Loom en Vidyard"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/andresampaio.js